import React from 'react'
import styled from 'styled-components'
import colors from 'theme/colors'
import breakpoints from 'theme/breakpoints'
import { Search } from 'react-feather'

export default function TabWallet({ toogleTab, selectedTab, searchTerm, onSearch }) {
    const items = [
        { name: 'active', label: 'Ativos' },
        { name: 'finish', label: 'Encerrados' },
    ]

    return (
        <TabContainer>
            <TabRow>
                <TabList>
                    {items.map((item) => (
                        <TabItem
                            key={item.name}
                            onClick={() => toogleTab(item.name)}
                            active={selectedTab === item.name}
                        >
                            {item.label}
                        </TabItem>
                    ))}
                </TabList>

                <SearchWrapper>
                    <SearchIcon>
                        <Search size={15} color={colors.nightLight} />
                    </SearchIcon>
                    <SearchInput
                        type="text"
                        placeholder="Buscar pelo nome, ingresso ou pedido"
                        value={searchTerm || ''}
                        onChange={(e) => onSearch?.(e.target.value)}
                    />
                </SearchWrapper>
            </TabRow>

            <TabDivider />
        </TabContainer>
    )
}

const TabContainer = styled.div`
    width: 100%;
    margin-top: 24px;
`;

const TabRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
`;

const TabList = styled.div`
    display: flex;
    gap: 6px;
    flex-shrink: 0;
`;

const TabItem = styled.button`
    position: relative;
    background: none;
    border: none;
    padding: 14px 16px;
    font-size: 16px;
    font-weight: ${({ active }) => active ? '700' : '500'};
    color: ${({ active }) => active ? colors.nightDark : colors.nightLight};
    cursor: pointer;
    transition: all .2s ease;
    white-space: nowrap;

    &::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 8px;
        right: 8px;
        height: 3px;
        background: ${({ active }) => active ? colors.occasionalPurple : 'transparent'};
        border-radius: 3px 3px 0 0;
        transition: background .2s ease;
    }

    &:hover {
        color: ${({ active }) => active ? colors.nightDark : colors.night};
    }

    @media screen and (min-width: ${breakpoints.md}) {
        padding: 16px 24px;
        font-size: 17px;
    }
`;

const SearchWrapper = styled.div`
    position: relative;
    display: none;

    @media screen and (min-width: ${breakpoints.md}) {
        display: flex;
        align-items: center;
        width: 320px;
        flex-shrink: 0;
    }
`;

const SearchInput = styled.input`
    width: 100%;
    padding: 9px 14px 9px 36px;
    border: 1px solid ${colors.neutralDark};
    border-radius: 6px;
    font-size: 13px;
    color: ${colors.nightDark};
    background: ${colors.neutralLight};
    outline: none;
    transition: all .2s ease;

    &::placeholder {
        color: ${colors.nightLight};
        font-size: 13px;
    }

    &:focus {
        border-color: ${colors.occasionalPurple};
        box-shadow: 0 0 0 3px ${colors.occasionalPurple}1A;
    }
`;

const SearchIcon = styled.div`
    position: absolute;
    left: 11px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    pointer-events: none;
    z-index: 1;
`;

const TabDivider = styled.div`
    width: 100%;
    height: 1px;
    background: ${colors.neutralDark};
`;
